"use client";
import { useQuery } from "@tanstack/react-query";
import { apiConfig } from "../../config";
import ApiCompany from "./api-company";
import { getCompanyKey, getKey } from "../../common-interfaces/quiries-keys/queries-keys";
import { useLangCookie } from "@/providers/langProvider";
import { Keys } from "../../common-interfaces/quiries-keys/keysValues";

export const useCompany = () => new ApiCompany(apiConfig());
export const useGetCompanyQuery = () => {
  const langCookie = useLangCookie();
  return useQuery(
    getCompanyKey(langCookie),
    useCompany().getCompany,
    {
      refetchOnWindowFocus: false,
      staleTime: Infinity,
    },
  );
};
export const useGetDialCodesQuery = () => {
  return useQuery([...getKey(Keys.get_dial_codes)], useCompany().getDialCodes, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    retry: false,
  });
};
export const useGetAllTransQuery = () => {
  return useQuery([...getKey(Keys.trans)], useCompany().getAllTranslations, {
    // Translations do not change mid-session, and on mobile "window focus" fires every
    // time the user returns from another app — this refetched the whole dictionary.
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};

export const useGetCurrenciesQuery = () => {
  return useQuery([...getKey(Keys.currencies)], useCompany().getCurrencies, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
